import { trace } from 'rytm-helpers';

export const initNewsletterForm = () => {
  // add event listener for form submit
  document.addEventListener("submit", onDocumentFormSubmit);
  document.addEventListener("click", onDocumentClick);
}

const onDocumentClick = (e) => {
  // on checkbox with dataset.checkGroup attribute change, reset custom validity
  if (e.target.dataset.checkGroup) {
    const checkboxes = [...document.querySelectorAll(`[data-check-group="${e.target.dataset.checkGroup}"]`)];
    checkboxes.forEach(checkbox => checkbox.setCustomValidity(''));
  }
}

const onDocumentFormSubmit = (e) => {
  // check if under this form are some inputs with the dataset.checkGroup attribute
  const groupedCheckboxes = [...e.target.querySelectorAll('[data-check-group]')];
  if (groupedCheckboxes.length) {
    // get all checkboxes that are checked
    const checkedCheckboxes = groupedCheckboxes.filter(checkbox => checkbox.checked);
    // if there are no checked checkboxes, prevent form submit
    if (!checkedCheckboxes.length) {
      e.preventDefault();
      // fire first invalid
      const msg = groupedCheckboxes[0].dataset.checkAlert || 'Please select at least one option';
      groupedCheckboxes[0].setCustomValidity(msg);
      groupedCheckboxes[0].reportValidity();
      return false;
    } else {
      trace("reset custom validity");
      // reset all custom validity messages
      groupedCheckboxes.forEach(checkbox => checkbox.setCustomValidity(''));
    }
  }
}